import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

import { createContext, memo } from "react";

export interface OrderEditingSuiteStatuses {
  orderEditingEnabled: boolean;
}

export const OrderEditingSuiteStatusesContext = createContext<
  OrderEditingSuiteStatuses | undefined
>(undefined);

export const OrderEditingSuiteStatusesProvider = memo(
  function OrderEditingSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);
    const tools = team?.settings?.orderEditing?.tools;

    const orderEditingEnabled =
      !!tools?.cancelOrder?.enabled ||
      !!tools?.changeAddress?.enabled ||
      !!tools?.addOrderDiscount?.enabled ||
      !!tools?.addOrderGiftNote?.enabled ||
      !!tools?.updateOrder?.enabled;

    return (
      <OrderEditingSuiteStatusesContext.Provider
        value={{ orderEditingEnabled }}
      >
        {children}
      </OrderEditingSuiteStatusesContext.Provider>
    );
  },
);
